/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigInputGradingRelevant } from './taskEvaluationConfigInputGradingRelevant';
import type { TaskEvaluationConfigInputFormalCriteriaSource } from './taskEvaluationConfigInputFormalCriteriaSource';
import type { TaskEvaluationConfigInputFormalCriteria } from './taskEvaluationConfigInputFormalCriteria';
import type { TaskEvaluationConfigInputFeedback } from './taskEvaluationConfigInputFeedback';
import type { TaskEvaluationConfigInputCompletionPolicyOverride } from './taskEvaluationConfigInputCompletionPolicyOverride';
import type { TaskEvaluationConfigInputCompletionMinLevelsOverride } from './taskEvaluationConfigInputCompletionMinLevelsOverride';
import type { TaskEvaluationConfigInputCompletionPolicyEffective } from './taskEvaluationConfigInputCompletionPolicyEffective';
import type { TaskEvaluationConfigInputCompletionMinLevelsEffective } from './taskEvaluationConfigInputCompletionMinLevelsEffective';

/**
 * Configuration for the evaluation of a task
 */
export interface TaskEvaluationConfigInput {
  mode?: string;
  gradingRelevant?: TaskEvaluationConfigInputGradingRelevant;
  formalCriteriaSource?: TaskEvaluationConfigInputFormalCriteriaSource;
  formalCriteria?: TaskEvaluationConfigInputFormalCriteria;
  feedback?: TaskEvaluationConfigInputFeedback;
  completionPolicyOverride?: TaskEvaluationConfigInputCompletionPolicyOverride;
  completionMinLevelsOverride?: TaskEvaluationConfigInputCompletionMinLevelsOverride;
  completionPolicyEffective?: TaskEvaluationConfigInputCompletionPolicyEffective;
  completionMinLevelsEffective?: TaskEvaluationConfigInputCompletionMinLevelsEffective;
}
